import axios from 'axios';
import { getAllQueueItems, updateQueueItem, deleteQueueItem } from './idb';

export async function flushQueue(onProgress) {
 const items = await getAllQueueItems();
 // Process only queued or error items
 const toProcess = items.filter((i) => ['queued', 'error'].includes(i.status));
 for (const item of toProcess) {
 try {
 onProgress && onProgress({ id: item.id, status: 'syncing' });
 await updateQueueItem(item.id, { status: 'syncing', lastAttemptAt: Date.now() });

 if (item.type === 'progress_log') {
 // Upload embedded files (if provided) first as documents
 const docIds = [];
 if (item.files && item.files.length) {
 for (const f of item.files) {
 const fd = new FormData();
 fd.append('file', f.blob, f.name || 'photo.jpg');
 fd.append('project_id', item.payload.project_id);
 fd.append('doc_type', 'PHOTOS');
 fd.append('related_entity_type', 'progress_log');
 const up = await axios.post('/cycle3/documents/upload', fd, {
 headers: { 'Content-Type': 'multipart/form-data' },
 });
 if (up?.data?.id) docIds.push(up.data.id);
 }
 }
 const body = { ...item.payload, photos: docIds };
 await axios.post('/cycle3/progress-logs', body);
 await deleteQueueItem(item.id);
 onProgress && onProgress({ id: item.id, status: 'done' });
 } else if (item.type === 'document_upload') {
 const fd = new FormData();
 fd.append('file', item.file.blob, item.file.name || 'file.bin');
 fd.append('project_id', item.meta.project_id);
 fd.append('doc_type', item.meta.doc_type);
 if (item.meta.related_entity_type) fd.append('related_entity_type', item.meta.related_entity_type);
 if (item.meta.related_entity_id) fd.append('related_entity_id', item.meta.related_entity_id);
 await axios.post('/cycle3/documents/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
 await deleteQueueItem(item.id);
 onProgress && onProgress({ id: item.id, status: 'done' });
 } else if (item.type === 'progress_log_v1') {
 // Fallback for quick Mark Done using v1 API
 await axios.post('/progress-logs', item.payload);
 await deleteQueueItem(item.id);
 onProgress && onProgress({ id: item.id, status: 'done' });
 } else {
 await deleteQueueItem(item.id);
 }
 } catch (e) {
 const msg = e?.response?.data?.detail || e?.message || 'Sync failed';
 await updateQueueItem(item.id, { status: 'error', error: msg });
 onProgress && onProgress({ id: item.id, status: 'error', error: msg });
 }
 }
}
